module.exports = __webpack_public_path__ + "img/bank-4.5cf642cc.jpg";